var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('HeaderV3', {
    attrs: {
      "meta": _vm.meta,
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm.onEventTime && !_vm.isLoading ? [_vm.editable ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.redeemCode,
      expression: "redeemCode"
    }],
    staticClass: "redeem__input",
    attrs: {
      "placeholder": "請輸入序號"
    },
    domProps: {
      "value": _vm.redeemCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.redeemCode = $event.target.value;
      }
    }
  }) : _c('div', {
    staticClass: "redeem"
  }, [_c('span', {
    staticClass: "redeem__code"
  }, [_vm._v(_vm._s(_vm.redeemCode))])])] : _vm._e(), _c('div', {
    staticClass: "card__divider"
  }), _c('div', {
    staticClass: "card__info"
  }, [!_vm.hasResult && !_vm.isLoading ? [_vm.onEventTime ? _c('div', {
    staticClass: "card__title"
  }, [_vm._v("說明")]) : _vm._e(), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.description)
    }
  })] : _vm._e(), _vm.gift.get_gift && _vm.hasResult ? [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.AwardText)
    }
  }), _c('img', {
    staticClass: "gift__image",
    attrs: {
      "src": _vm.gift.image_url
    }
  })])] : _vm._e(), !_vm.gift.get_gift && _vm.hasResult ? [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.noAwardText)
    }
  })])] : _vm._e(), _vm.isLoading ? [_c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    },
    attrs: {
      "variant": "secondary",
      "large": ""
    }
  })], 1)] : _vm._e()], 2)], 2), !_vm.hasResult && _vm.onEventTime ? _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function click($event) {
        return _vm.redeem();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])]) : _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.redirectLine();
      }
    }
  }, [_vm._v(" 回 LINE 官方帳號 ")])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }